import { all, call } from "redux-saga/effects";
import handleError from "@fas/cpa-state-manager/redux/sagas/handleError";

export default function* mainSaga() {
  yield all([call(handleError)]);
}
